import React, { useMemo } from 'react'

import classNames from 'classnames'
import groupBy from 'lodash/groupBy'
import map from 'lodash/map'

import { ProductionDetailsProvider } from '@/context/production-details'
import { Production } from '@/types/app-types'

import { BEST_BROADWAY_COLUMNS, CHEAP_TICKETS_COLUMNS } from './constants'
import ProductionCard from './production-card'
import styles from './styles.module.scss'

interface Props {
    numberOfColumns: number
    productions: Production[]
    categoryImage: string | undefined
    containerTestId: string
}

const ProductionCardContainer: React.FC<Props> = ({ numberOfColumns, productions, categoryImage, containerTestId }) => {
    const mergedClassNames = classNames(styles.productionCardContainer, {
        [styles.grid4]: numberOfColumns === CHEAP_TICKETS_COLUMNS,
        [styles.grid3]: numberOfColumns === BEST_BROADWAY_COLUMNS,
    })

    const groupedProductions = useMemo(() => {
        const filteredProductions = productions.filter((production) => production.minPrice > 20)
        const groupedProductions = groupBy(filteredProductions, (production) => production.performers?.[0]?.webPath)
        return (
            map(groupedProductions, (items) => {
                const shouldAddMoreDates = items.length > 1
                return { ...items[0], shouldAddMoreDates }
            }) || []
        )
    }, [productions])

    const productionCards = useMemo(() => {
        const numberOfCards = numberOfColumns === BEST_BROADWAY_COLUMNS ? 15 : 8
        return groupedProductions.slice(0, numberOfCards).map((production) => (
            <ProductionDetailsProvider key={production.id} initialParams={{ productionId: production.id }}>
                <ProductionCard
                    numberOfColumns={numberOfColumns}
                    categoryImage={categoryImage}
                    production={production}
                    shouldAddMoreDates={production.shouldAddMoreDates}
                />
            </ProductionDetailsProvider>
        ))
    }, [groupedProductions, categoryImage, numberOfColumns])

    return (
        <section className={mergedClassNames} data-testid={containerTestId}>
            {productionCards}
        </section>
    )
}

export default ProductionCardContainer
